angular.module('rjmNg.directives').directive "metricPerspective", [
  "figureEnums"
  "reportBuilder"
  (
    figureEnums
    reportBuilder
  ) ->
    restrict: "E"
    templateUrl: "directive.metricPerspective.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      metric: "="
      isPerspectiveAllowed: "="
      updateReport: "="
      popover: "="
      tables: "="
      columns: "="
      globalTimeInterval: "="
    controller: [
      "logger"
      (logger) ->
        view = @
        view.cohortMemberCountChoices = []
        view.cohortMemberCountChoice = null
        view.isCohortMemberPerspective = false
        view.DATA_PERSPECTIVES = figureEnums.DATA_PERSPECTIVES

        # Track when any perspective option is clicked in list
        _logEvent = (perspective) ->
          logger.log("Data Perspective Usage", "Click", 1, "click", perspective)

        _getCountingMembersChoices = (metric, columns) ->
          _.uniq(
            [
              reportBuilder.getCountingMembers(metric, columns, true)
              reportBuilder.getCountingMembers(metric, columns, false)
            ]
          , false
          , (mc) ->
            mc.table
          )

        _setIsCohortMemberPerspective = () ->
          view.isCohortMemberPerspective = view.selectedPerspective in [
            'cumulativeAverageValuePerCohortMember'
            'averageValuePerCohortMember'
          ]

        # Set default average window length the first time a user clicks on the Rolling Averages perspective
        view.checkAverageWindowLength = () ->
          if view.selectedPerspective is 'rollingAverage' and !view.selectedWindowLength
            view.selectedWindowLength = figureEnums.PERSPECTIVE_CONSTANTS.DEFAULT_AVERAGE_WINDOW_LENGTH

        view.setPerspective = (perspectiveType, memberCount = null) ->
          view.metric.perspective = perspectiveType

          if memberCount?
            view.metric['counting-members'] = memberCount

          if perspectiveType is 'rollingAverage'
            view.metric.averageWindowLength = view.selectedWindowLength

          if view.updateReport?
            view.updateReport()

        view.restorePerspective = () ->
          view.selectedPerspective = view.metric.perspective
          _setIsCohortMemberPerspective()

          if view.selectedPerspective is 'rollingAverage' and view.metric.averageWindowLength?
            view.selectedWindowLength = view.metric.averageWindowLength

          if view.isCohortMemberPerspective
            view.cohortMemberCountChoices = _getCountingMembersChoices(view.metric, view.columns)
            view.cohortMemberCountChoice = view.metric['counting-members']
          else
            view.cohortMemberCountChoice = null

          view.metric.perspectiveChanged = false

        view.checkIfPerspectiveChanged = () ->
          if view.selectedPerspective isnt view.metric.perspective or
            view.cohortMemberCountChoice isnt view.metric['counting-members']
              view.metric.perspectiveChanged = true
          else
            view.metric.perspectiveChanged = false

        view.checkIfWindowLengthChanged = () ->
          view.metric.windowLengthChanged = view.selectedWindowLength isnt view.metric.averageWindowLength

        view.setSelectedPerspective = (perspective) ->
          view.selectedPerspective = perspective
          _setIsCohortMemberPerspective()
          _logEvent(perspective)

          if view.isCohortMemberPerspective
            view.cohortMemberCountChoices = _getCountingMembersChoices(view.metric, view.columns)
            view.cohortMemberCountChoice = view.cohortMemberCountChoices[0]
          else
            view.cohortMemberCountChoice = null

        view.cancel = () ->
          view.popover.hide()

        view.apply = () ->
          view.setPerspective(view.selectedPerspective, angular.copy(view.cohortMemberCountChoice))
          view.popover.hide()

        view.cleanUp = () ->
          view.metric.perspectiveChanged = false
          return

        view.$onInit = () ->
          view.restorePerspective()

        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watch("view.selectedPerspective", view.checkIfPerspectiveChanged, true)
      scope.$watch("view.selectedPerspective", view.checkAverageWindowLength, true)
      scope.$watch("view.cohortMemberCountChoice", view.checkIfPerspectiveChanged, true)

      scope.$on('$destroy', view.cleanUp)

      scope.$watch('view.popover.visible', (visible, old) ->
        if visible is false
          view.restorePerspective()
      )

      scope.$watch('view.metric.perspective', (newPerspective, oldPerspective) ->
        if newPerspective isnt oldPerspective
          view.restorePerspective()
      )

      scope.$watch('view.metric["counting-members"]', (newCountingMembers, oldCountingMembers) ->
        if not angular.equals(newCountingMembers,oldCountingMembers)
          view.restorePerspective()
      , true)
]
